import { cookie } from 'helpers/cookie'
export const AUTH_TOKEN_NAME = 'auth_token'

const getToken = () => cookie.get(AUTH_TOKEN_NAME) || undefined

const setToken = (token: string) => cookie.set(AUTH_TOKEN_NAME, token)

const removeToken = () => cookie.remove(AUTH_TOKEN_NAME)

const hasToken = () => !!getToken()

export const authToken = { getToken, setToken, removeToken, hasToken }
